<template>
  <v-container>
    <v-row md="12">
      <v-col class="topic" md="7" data-aos="fade-up">
        <h1>Get In Touch</h1>
        <h2>Let's talk about everything!</h2>
        <p>Follow me in social media or Send me an following with email. 👋<br>
           asrilerd@gmail.com or srilerdaun@gmail.com
        </p>
        <!-- <v-divider></v-divider> -->
        <v-row class="iconBigSocial" no-gutters>
          <v-col md="2" xs="1"
            ><img @click="facebook()" src="@/assets/facebook2.png"
          /></v-col>
          <v-col md="2" xs="1"
            ><img @click="ig()" src="@/assets/instagram2.png"
          /></v-col>
          <v-col md="2" xs="1"
            ><img @click="git()" src="@/assets/github2.png"
          /></v-col>
        </v-row  >
      </v-col>
      <v-col md=6></v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  methods: {
    facebook() {
      window.open("https://www.facebook.com/aunyamaneesri/");
    },
    ig() {
      window.open("https://www.instagram.com/apunn/");
    },
    git() {
      window.open("https://github.com/aunyamanee7112");
    },
  },
};
</script>

<style scoped>
.topic {
  color: #48445E;
}
.topic h1 {
  font-family: "Poppins", sans-serif;
  font-size: 45px;
  color: #6C6CE5 !important;
}
.topic h2 {
  font-family: "Poppins", sans-serif;
  font-size: 20px;
  /* color: rgb(0, 0, 0) !important; */
}
.topic p {
  font-family: "Poppins", sans-serif;
  font-size: 15px;
  /* color: rgb(0, 0, 0) !important; */
}
img {
  width: 70px;
  padding: 20px;
  border-radius: 50px;
  box-shadow: 1rem 1rem 2rem rgba(0, 0, 0, 0.1),
    -1rem -1rem 2rem rgb(255, 255, 255);
}
img:hover {
  box-shadow: inset 0.5rem 1rem 0.4rem rgba(0, 0, 0, 0.1),
    inset -1rem -1rem 2rem rgb(255, 255, 255);
}
.iconBigSocial {
  margin-top: 2em;
}
</style>
